import { NUMERIC, VALID_FORMATS } from './consts';
import { isValidDate, getValidLocale } from './helpers';

/**
 * `displayTime` takes a `Date` object and a format specifier, and returns a string representing time that is formatting according to format for the user's locale.
 * @param date - `Date` object or `number` to display as `string`.
 * @param options - parameters object available for the Intl.DateTimeFormat() constructor:
 *   * `format` - either "default", "short", or "numeric".
 *   * `locale` - developer designated locale (this will take precedence over browser setting, if language differs).
 *   * `timeZone` - converts `date` to the given timezone.
 *   * `hour12` - whether to use 12-hour time (as opposed to 24-hour time).
 *   * `utc` - converts `date` to UTC timezone if true. Defaults to false.
 * See MDN docs for complete list of options: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options
 * @returns a locale date string corresponding to current user's locale and format options.
 */
export const displayTime = function (date) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!isValidDate(date)) {
    throw new TypeError('The first argument must be a valid date.');
  }
  const {
    format,
    locale,
    utc,
    timeZone,
    hour12
  } = options;
  if (!VALID_FORMATS.has(format)) {
    const supported = Array.from(VALID_FORMATS).filter(f => !!f).map(f => JSON.stringify(f));
    supported[2] = `or ${supported[2]}`;
    throw new TypeError(`The format must be either: ${supported.join(',')}.`);
  }
  const _options = {};
  _options.minute = NUMERIC;
  _options.hour = NUMERIC;
  _options.timeZone = timeZone || (utc ? 'UTC' : undefined);
  _options.hour12 = hour12;
  const localeId = getValidLocale(locale);
  return date.toLocaleTimeString(localeId, _options);
};
//# sourceMappingURL=displayTime.js.map